import React from 'react';
import { FormResponseWrapper } from 'organisms/requestCallForm/FormResponseStyles';

const QualifiedProResponse = (): JSX.Element => {
  return (
    // ID Necessary for GTM tracking
    <FormResponseWrapper id="qualifiedBiz">
      <strong>Thank you!</strong>

      <p>We appreciate your interest in Mighty Pro.</p>
      <p>Based on your revenue of under $250,000, we recommend starting on The Business Plan before exploring Mighty Pro further.</p>
      <p>Mighty Pro is for established brands, organizations, and successful creators. </p>
      <p>Our Mighty Pro customers generally have revenue above $250,000 a year and are looking to level up their courses, live events, member experience, and community with branded apps they own and control.</p>
      <p>For customers with revenue under $250,000 per year, The Business Plan is a great place to build your online business and community. To learn more about The Business Plan, <a href="https://calendly.com/customer-advocacy-mn/business-plan-intro" target="_blank" rel="noreferrer noopener">click here to schedule a 20-minute demo.</a>
      </p>
      <p>The Business Plan team will give you a tour and answer any questions.</p>
      <p>See you on The Business Plan!</p>
    </FormResponseWrapper>
  );
};

export default QualifiedProResponse;
